export default __webpack_public_path__ + "static/media/l5-p6.b251f795.svg";